import React, {useState} from "react";
import {inject, observer} from "mobx-react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import TextareaAutosize from "react-textarea-autosize";
//local
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {getFullName} from "helpers/helper";
import {JOINING_ORG} from "constants/routes.const";
import {showSuccess} from "helpers/notifications.helper";
import {roles} from "constants/auth.const";

// the company already has an account and the request to join it was sent at onboarding
export const ModalExists = inject("store")(
  observer(({store: {auth}}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const organization = auth.organizations.length && auth.organizations[0];
    const users = (organization?.Users ?? [])
      .filter(
        (user) =>
          user.OrganizationMember.role === roles.OWNER ||
          user.OrganizationMember.role === roles.ADMIN
      )
      .map((user) => getFullName(user.firstName, user.lastName));
    const lastUser = users.pop();
    const usersRow = `${users.join(", ")}${users.length ? t("AND") : ""} ${lastUser}`;

    const goToWaitingPage = () => {
      auth.updateAuthModalName();
      navigate(JOINING_ORG);
    };

    const handleDone = () => {
      if (!message.trim()) return goToWaitingPage();
      setLoading(true);
      auth
        .updateJoinRequestMessage(message.trim())
        .then(goToWaitingPage)
        .catch(() => setLoading(false));
    };

    const handleWithdraw = () => {
      setLoading(true);
      auth
        .withdrawJoinRequest()
        .then(() => {
          // the onboarding form starts over without the used code
          auth.setRequestId(null);
          auth.updateAuthModalName();
          showSuccess(
            t("JOIN_REQUEST_WITHDRAWN", "Förfrågan är avbruten. Ange rätt företag.")
          );
        })
        .catch(() => setLoading(false));
    };

    if (!organization) return null;

    return (
      <div className="modal-request">
        <h2>
          {t("JOIN_REQUEST_SENT_TITLE", {
            defaultValue: "{{name}} har redan ett konto i HandyDay",
            name: organization.name,
          })}
        </h2>
        <div className="modal-request__text">
          {lastUser
            ? t("JOIN_REQUEST_SENT_TEXT", {
                defaultValue:
                  "Vi har skickat din förfrågan om att gå med till {{admins}}. När den har godkänts får du tillgång till kontot.",
                admins: usersRow,
              })
            : t(
                "JOIN_REQUEST_SENT_TEXT_NO_ADMINS",
                "Företaget har ingen administratör i HandyDay än. Vi har skickat din förfrågan till HandyDays support, som hjälper dig vidare."
              )}
        </div>
        <div className="modal-request__textarea">
          <div>{t("MODAL_REQUEST_TEXTAREA_DESCRIPTION")}</div>
          <TextareaAutosize
            maxRows="4"
            minRows="2"
            className="textarea"
            name="messageText"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder={t("MODAL_REQUEST_TEXTAREA_PLACEHOLDER")}
          />
        </div>
        <ButtonTransparent
          large
          addClass="modal-request__button mb-4"
          nonTransparent
          loading={loading}
          disabled={loading}
          onClick={handleDone}
          name={t("DONE")}
        />
        <ButtonTransparent
          small
          addClass="mb-8"
          color="red"
          disabled={loading}
          onClick={handleWithdraw}
          name={t("JOIN_REQUEST_WRONG_COMPANY", "Fel företag? Avbryt förfrågan")}
        />
        <p>{t("ORG_EXISTS_SUPPORT_1")}</p>
        <p className="mb-8">{t("ORG_EXISTS_SUPPORT_2")}</p>
      </div>
    );
  })
);
